package dev.mft.website.composable.footer

import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Image
import androidx.compose.foundation.gestures.animateScrollBy
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import dev.mft.website.classes.Technology
import org.jetbrains.compose.resources.painterResource

@Composable
fun SkillContent(
    imageSize: Dp,
    skills: List<Technology>,
    direction: Float
) {
    val itemCount = skills.size * 1_000_000
    val listState = rememberLazyListState(
        initialFirstVisibleItemIndex = itemCount / 2
    )

    LaunchedEffect(Unit) {
        listState.scrollToItem(itemCount / 2)

        while (true) {
            listState.animateScrollBy(
                direction,
                animationSpec = tween(2000, easing = LinearEasing)
            )

            if (listState.firstVisibleItemIndex > itemCount - skills.size * 10) {
                listState.scrollToItem(itemCount / 2)
            }
        }
    }

    LazyRow(
        state = listState,
        horizontalArrangement = Arrangement.spacedBy(24.dp),
        verticalAlignment = Alignment.CenterVertically,
        userScrollEnabled = false
    ) {
        items(itemCount) { index ->
            val skill = skills[index % skills.size]
            Box(
                modifier = Modifier
                    .size(imageSize)
            ) {
                Image(
                    modifier = Modifier.fillMaxSize(),
                    painter = painterResource(skill.resourceId),
                    contentDescription = skill.contentDescription,
                    contentScale = ContentScale.Crop
                )
            }
        }
    }
}